import React from 'react';
import { classNames } from 'libs/react';
import { Link } from './Link';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import './MapButton.scss';
/**
 * @component MapButton
 * @since 1.0.0
 * @hidden
 */
export function MapButton(props) {
    const { picto, label, entity } = Object.assign({ picto: 'map' }, props);
    const className = classNames('map-button');
    return (React.createElement(Link, { className: className, route: { name: entity + '.find' } },
        picto && React.createElement(Icon, { className: "map-button-picto", value: picto }),
        label && React.createElement(Text, { value: label })));
}
